window.addEventListener('DOMContentLoaded', function() {

/**
 * Function to wrap iframes with a specified class based on the presence of certain keywords in their src attribute.
 * @param {string[]} keywords - Array of keywords to look for in the iframe src attribute.
 * @param {string} wrapperClass - The CSS class to apply to the wrapping element.
 */
function wrapIframesBySrc(keywords, wrapperClass) {
  // Create a selector based on the keywords
  const selectors = keywords.map(keyword => `iframe[src*="${keyword}"]`).join(',');

  // Find all iframes that match the selector
  const iframes = document.querySelectorAll(selectors);

  // Wrap each iframe with a div that has the specified class
  iframes.forEach(iframe => {
    const wrapper = document.createElement('div');
    wrapper.className = wrapperClass;
    iframe.parentNode.insertBefore(wrapper, iframe);
    wrapper.appendChild(iframe);
  });
}

// Usage example: Wrap YouTube and Vimeo iframes with 'video-wrapper' class
wrapIframesBySrc(['youtube.com/embed', 'player.vimeo'], 'video-wrapper');


  
   const bodyElement = document.querySelector('body');
    let cartQtyObserver;

    const startObservingCartQty = function() {
        const cartQtyElement = document.querySelector('.cart-drawer__item-qty');
        
        if (cartQtyElement) {
            cartQtyObserver = new MutationObserver(function(mutationsList, observer) {
                for(const mutation of mutationsList) {
                    if (mutation.type === 'childList' || mutation.type === 'characterData') {
                        const qtyText = cartQtyElement.innerHTML;
                        const qty = qtyText.match(/\d+/) ? qtyText.match(/\d+/)[0] : '0';
                        
                        // Select all .header-count elements and update each
                        document.querySelectorAll('.header-count').forEach(headerCountElement => {
                            headerCountElement.innerHTML = qty;
                        });
                    }
                }
            });

            const config = { attributes: false, childList: true, subtree: true, characterData: true };
            cartQtyObserver.observe(cartQtyElement, config);
        } else {
            console.error('cart-drawer__item-qty element not found');
        }
    };

    // Body observer remains the same...
    const bodyObserver = new MutationObserver(function(mutations) {
        mutations.forEach(mutation => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const bodyClassList = bodyElement.classList;
                if (bodyClassList.contains('js-drawer-open-cart')) {
                    startObservingCartQty();
                } else {
                    // Optionally stop observing cartQtyElement if needed
                    // stopObservingCartQty();
                }
            }
        });
    });

    bodyObserver.observe(bodyElement, {
        attributes: true,
        attributeFilter: ['class']
    });
  
  setTimeout(function() {
    englishProductTitleGrid();
  }, 5000); // Delay of 5 seconds
  
});

function englishProductTitleGrid() {
  let cutString = '|';
  let productGridItems = document.querySelectorAll('.product-grid-item__title');

  productGridItems.forEach(function(productGridItem) {
    if (productGridItem.textContent.includes(cutString)) {
      let stringArray = productGridItem.textContent.split(cutString);
      productGridItem.textContent = stringArray[0];
      let engTitle = document.createElement('span');
      engTitle.className = 'product-card__title--eng';
      engTitle.textContent = stringArray[1];
      productGridItem.appendChild(engTitle);
    }
  });
}

let myInterval = setInterval(function(){
    if (window.jQuery) {
         let productPage = {
          englishProductTitle: () => {
              let cutString = '|';
              $('.product__title').each(function(k,v){
                  if ($(v).text().includes(cutString)){
                      let stringArray = $(v).text().split(cutString);
                      $(this).text(stringArray[0]).append(`<span class="product-card__title--eng">${stringArray[1]}</span>`);    
                  }
              });
          },
          descriptionTop: () => {
              if ($('.template-product .product-single__description.rte section.top').length > 0){
                  let topDesc = $('.product-single__description.rte section.top').clone();
                  $('.description_top').prepend(topDesc);
              }
              $('.orange-bullets li').each(function(k,v){
                  $(v).prepend('<img class="orange-bullets-img" src="https://cdn.shopify.com/s/files/1/0505/4500/0617/files/checked.svg?v=1618220685"/>')
              });
          },
          newDescriptionTop: () => {
              if ($('.template-product .custom-block-content section.top').length > 0){
                  let topDesc = $('.custom-block-content section.top').clone();
                  $('.description_top').prepend(topDesc);
              }
          },
          run: () => {
              productPage.englishProductTitle();
              productPage.descriptionTop();
              productPage.newDescriptionTop();
          }
      }
      let cart = {
          init: () => {
              let cutString = '|';
              $('.template-cart .cart__product-title').each(function(k,v){
                  if ($(v).text().includes(cutString)){
                      let stringArray = $(v).text().split(cutString);
                      $(this).text(stringArray[0]).append(`<span class="cart__title--eng">${stringArray[1]}</span>`);    
                  }
              });
          },
          run: () => {
              cart.init();
          }
      }
     $(function(){
        productPage.run();
        cart.run();
      })
     clearInterval(myInterval);
    }
}, 500)